import React, { CSSProperties } from "react";
import "./shimmer.css"; // shimmer animation styles

type ShimmerProps = {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  className?: string;
  externCss?: CSSProperties; // external inline styles
};

const Shimmer: React.FC<ShimmerProps> = ({
  width = "140px",
  height = "18px",
  borderRadius = "6px",
  className,
  externCss
}) => {
  const style: CSSProperties = {
    width,
    height,
    borderRadius,
  };

  return (
    <div
      className={`shimmer ${className || ""}`}
      style={{ ...style, ...externCss }}
    ></div>
  );
};

export default Shimmer;
